<div class="main-help-icon"
    id="main-help-menu-icon"
    [nTooltip]="helpMenu"
    nTooltipTrigger="click"
    nTooltipTheme="black"
    [nTooltipPlacement]="isSmallSize ? 'leftTop' : 'bottomRight'"
    [(nTooltipVisible)]="tooltipVisible"
    [nTooltipOverlayClass]="isSmallSize ? ['help-menu', 'small-size'] : ['help-menu']">

    <svg class="icon header-icon" [nTooltip]="isSimpleMode ? i18nLabel.help : null" nTooltipPlacement="bottomRight">
        <use [attr.xlink:href]="isSimpleMode ? '#app-icon-header-help-simple' : '#app-icon-header-help'"></use>
    </svg>
</div>

<ng-template #helpMenu>
    <div class="help-menu-container">
        <section class="help-menu-section">
            <h2>{{i18nLabel.help}}</h2>
            <!-- 联机帮助 -->
            <n-help-link mode="text"
                [labelText]="i18nLabel.onlineHlep"
                [key]="SWITCH.IS_SIMPLE_MODE ? 'simplifyHelp' : 'default'">
            </n-help-link>
            <!-- 新手引导 -->
            <div
                *ngIf="FeatureConfig.IsSupportOpenQuickStart && !isVstoreSystem"
                class="n-help-link"
                mode="text"
                (click)="openQuickStart()">
                <div class="help-wrapper ng-star-inserted">
                    <span class="ng-star-insertde">{{i18nLabel.helpTaskLabel}}</span>
                </div>
            </div>
            <!-- 技术支持官网 -->
            <n-help-link mode="text"
                [labelText]="i18nLabel.support"
                [url]="helpUrl.support"
                key="default"
                *ngIf="isNotOem">
            </n-help-link>
            <!-- 联系智能客服 -->
            <div class="n-help-link" id="help-memu-intelligent-qa" mode="text" (click)="showCustomerService()" *ngIf="isNotOem && isZh">
                <div class="help-wrapper ng-star-inserted">
                    <span class="ng-star-insertde">{{i18nLabel.intelligentCustomerServiceLab}}</span>
                </div>
            </div>
            <!-- 关于 -->
            <div class="n-help-link" mode="text"
                (click)="aboutShowOn()">
                <div class="help-wrapper ng-star-inserted">
                    <span class="ng-star-insertde">{{i18nLabel.about}}</span>
                </div>
            </div>
        </section>
        <section class="help-menu-section" *ngIf="isNotOem">
            <h2>{{i18nLabel.technicalSupport}}</h2>
            <!-- 信息中心 -->
            <n-help-link mode="text"
                *ngIf="showSelfService"
                [labelText]="i18nLabel.selfService"
                [url]="helpUrl.selfService"
                key="default">
            </n-help-link>
            <!-- 服务公告 -->
            <n-help-link mode="text"
                [labelText]="i18nLabel.bulletin"
                [url]="helpUrl.bulletin"
                key="default">
            </n-help-link>
            <!-- 社区论坛 -->
            <n-help-link mode="text"
                [labelText]="i18nLabel.forum"
                [url]="helpUrl.forum"
                key="default">
            </n-help-link>
            <!-- CRU更换工具 -->
            <n-help-link mode="text"
                [labelText]="i18nLabel.downloadCRUTool"
                [url]="helpUrl.downloadCRUTool"
                key="default"
                *ngIf="isCruShow && !isVstoreSystem">
            </n-help-link>
            <!-- CRU更换教程 -->
            <n-help-link mode="text"
                [labelText]="i18nLabel.userReplaceableUnit"
                [url]="helpUrl.userReplaceableUnit"
                key="default"
                *ngIf="isCruShow && !isVstoreSystem && isShowUserReplaceableUnit">
            </n-help-link>
        </section>
    </div>
</ng-template>
